import { render, staticRenderFns } from "./ChatSettings.vue?vue&type=template&id=4a784915&"
import script from "./ChatSettings.vue?vue&type=script&lang=js&"
export * from "./ChatSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettings.vue?vue&type=style&index=0&id=4a784915&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports